module.exports = __webpack_public_path__ + "static/media/pizzas.7574735c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/pizzas.svg
// module id = 71
// module chunks = 0